import React, { useEffect, useState, useRef } from "react";
import CloseForm from "./CloseForm";
import "../../css_files/Master/MoreCustomerMasterDetails.css";
import axios from "axios";
import getCookie from "../../api";
import axiosInstance from "../../api";

function MoreCustomerMasterDetails({
  setshowmorecustomerdata,
  customerupdatedata,
  loading,
}) {
  const [greaterarray, setgreaterarray] = useState([]);

  const [CustomerAddressData, setCustomerAddressData] = useState([]);

  useEffect(() => {
    setCustomerAddressData(customerupdatedata?.addresses);
  }, [customerupdatedata?.addresses]);

  useEffect(() => {
    const largestArray = [
      customerupdatedata?.customerBoilers,
      customerupdatedata?.addresses,
      customerupdatedata?.contactCentres,
    ].reduce((max, arr) => (arr.length > max.length ? arr : max), []);
    setgreaterarray(largestArray);
  }, [customerupdatedata]);

  return (
    <section className="more-customer-master-details">
      <section className="table" style={{ width: "70%" }}>
        <h1>More Customer Details</h1>
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(6, 1fr)" }}>
              <blockquote style={{ minWidth: "5rem" }}>Customer Id</blockquote>
              <blockquote style={{ minWidth: "15rem" }}>
                Customer Name
              </blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Contact</blockquote>
              <blockquote style={{ minWidth: "15rem" }}>
                Address Type
              </blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Address</blockquote>
              <blockquote style={{ minWidth: "15rem" }}>Boiler</blockquote>
            </aside>
          </div>
          <div>
            {greaterarray.map((_, idx) => (
              <aside
                key={idx}
                style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
              >
                <blockquote style={{ minWidth: "5rem" }}>
                  {customerupdatedata?.id}
                </blockquote>
                <blockquote style={{ minWidth: "15rem" }}>
                  {customerupdatedata?.orgName}
                </blockquote>

                <blockquote style={{ minWidth: "15rem" }}>
                  {customerupdatedata?.contactCentres[idx] ? (
                    <>
                      {customerupdatedata?.contactCentres[idx].salutation}
                      {customerupdatedata?.contactCentres[idx].name + " ,"}
                      <br />
                      <p>
                        Designation:{" "}
                        {customerupdatedata?.contactCentres[idx].designation}
                      </p>
                      <p>
                        Email: {customerupdatedata?.contactCentres[idx].email}
                      </p>
                      <p>
                        PhoneNumber:{" "}
                        {customerupdatedata?.contactCentres[idx].phoneNumber}
                      </p>
                    </>
                  ) : (
                    "N/A"
                  )}
                </blockquote>
                <blockquote style={{ minWidth: "15rem" }}>
                  {CustomerAddressData[idx] ? (
                    <>
                      {CustomerAddressData[idx].addressType}, <br />
                      <p
                        style={{
                          display: "inline-block",
                          textDecoration: "underline",
                        }}
                      >
                        {CustomerAddressData[idx].addressType} Name:
                      </p>
                      {CustomerAddressData[idx].addressType === "Factory"
                        ? CustomerAddressData[idx].factoryName
                        : CustomerAddressData[idx].officeName}
                    </>
                  ) : (
                    "N/A"
                  )}
                </blockquote>
                <blockquote style={{ minWidth: "15rem" }}>
                  {CustomerAddressData[idx]
                    ? `${CustomerAddressData[idx].address1},${
                        CustomerAddressData[idx].address2
                      }, ${
                        CustomerAddressData[idx]?.cityObj?.name ||
                        CustomerAddressData[idx]?.cityName
                      }, ${
                        CustomerAddressData[idx]?.stateObj?.name ||
                        CustomerAddressData[idx]?.stateName
                      }, ${CustomerAddressData[idx].country}, ${
                        CustomerAddressData[idx].pincode
                      }`
                    : "N/A"}
                </blockquote>
                <blockquote style={{ minWidth: "15rem" }}>
                  {customerupdatedata?.customerBoilers[idx] ? (
                    <>
                      <p>
                        Boiler Head:{" "}
                        {customerupdatedata?.customerBoilers[idx]?.boiler?.head}
                      </p>
                      <p>
                        Boiler Series:{" "}
                        {
                          customerupdatedata?.customerBoilers[idx]
                            ?.boilerSeriess?.seriesCode
                        }
                      </p>
                      <p>
                        Purchase Date:{" "}
                        {new Date(
                          customerupdatedata?.customerBoilers[idx].purchaseDate
                        ).toLocaleDateString("en-US", {
                          weekday: "long",
                          day: "2-digit",
                          year: "numeric",
                          month: "long",
                        })}
                      </p>
                      <p>
                        Sr.No. {customerupdatedata?.customerBoilers[idx].srNo}
                      </p>
                    </>
                  ) : (
                    "N/A"
                  )}
                </blockquote>
              </aside>
            ))}
          </div>
        </section>
      </section>
      <CloseForm close={setshowmorecustomerdata} />
      {loading && (
        <blockquote
          style={{ width: "100%", textAlign: "center", margin: "2rem 0" }}
        >
          <i
            class="fa-solid fa-rotate-right fa-spin fa-3x"
            style={{ color: "#072b2b" }}
          ></i>
        </blockquote>
      )}
    </section>
  );
}

export default MoreCustomerMasterDetails;
